<template>
  <div :class="$style.header">
    <div :class="$style.header__inner">

      <div :class="$style.header__logo">
        <img src="../assets/logo.png">
      </div>
    
    </div>
  </div>
</template>

<script>
export default {
  name: 'siteHeader'
}
</script>

<style lang="stylus" module src="../styles/SiteHeader.styl"></style>


// WEBPACK FOOTER //
// SiteHeader.vue?2700566b